export function getCsrfToken(name = "csrftoken") {
  let cookieValue = null;
  if (document.cookie && document.cookie != "") {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = jQuery.trim(cookies[i]);
      // DOES THIS COOKIE STRING BEGIN WITH THE NAME WE WANT?
      if (cookie.substring(0, name.length + 1) == name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export default function xhrConfig() {
  let csrftoken = getCsrfToken();

  function csrfSafeMethod(method) {
    // THESE HTTP METHODS DO NOT REQUIRE CSRF PROTECTION
    return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
  }

  $.ajaxSetup({
    beforeSend: function (xhr, settings) {
      if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
      }
    }
  });
}

export function fetchWithCSRF(url, options) {
  let csrftoken = getCsrfToken();

  // CHECK IF THE METHOD IS SAFE AND DOESN'T REQUIRE CSRF PROTECTION
  const isSafeMethod = /^(GET|HEAD|OPTIONS|TRACE)$/.test(options.method);

  // IF IT'S NOT A SAFE METHOD, ADD CSRF TOKEN
  if (!isSafeMethod) {
    options.headers = {
      ...options.headers,
      "X-CSRFToken": csrftoken
    };
  }

  return fetch(url, options);
}
